import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
    selector: 'app-pb-lead-gen-form',
    templateUrl: './pb-lead-gen-form.component.html',
    styleUrls: ['./pb-lead-gen-form.component.scss']
})
export class PbLeadGenFormComponent implements OnInit {

    @Input() section: any = {};
    @Input() content: any = {};
    @Input() module: any = {};
    paddingTop: any = '';
    paddingBottom: any = '';
    items: any = [];
    courses: any = [];
    courseKeyExists = false;
    additionalInfoExists = false;
    courseKey: any = '';
    courseTitle: any = '';
    AdditionalInfo: any = {};
    leadGenForm;

    firstName: any = '';
    lastName: any = '';
    emailAddress: any = '';
    phoneNumber: any = '';
    institute: any = '';
    subscribe: any = '';

    processing = false;
    success = false;

    constructor(private cd: ChangeDetectorRef, private api: ApiService, private formBuilder: FormBuilder, private router: Router) {

        this.leadGenForm = this.formBuilder.group({
            firstName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$')
            ])),
            lastName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$')
            ])),
            emailAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
                Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
            ])),
            phoneNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[0-9]*$'),
            ])),
            institute: new FormControl('', Validators.compose([
                Validators.required
            ])),
            subscribe: new FormControl('')
        });

    }

    ngOnInit(): void {

        // console.log('section', this.section);

        this.fetchCourses();
        this.courseKeyExists = !!this.module.prebuilt_module_data?.CourseKey;

        // Remove required validation for the institute field
        if (this.courseKeyExists) {
            const instituteField = this.leadGenForm.get('institute');
            instituteField?.clearValidators();
            instituteField?.updateValueAndValidity();
        }

        this.content.forEach(element => {
            const item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            };

            this.items.push(item);
        });

        this.paddingTop = this.module.paddingTop; // Module Padding
        this.paddingBottom = this.module.paddingBottom;

        this.additionalInfoExists = !!this.module.prebuilt_module_data?.AdditionalInfo;

        // Load AdditionalInfo configuration
        if (this.additionalInfoExists) {
            this.AdditionalInfo = this.module.prebuilt_module_data.AdditionalInfo;

            // Convert AdditionalInfoItem Object to array of Objects
            this.AdditionalInfo.AdditionalInfoItem = Object.keys(
                this.AdditionalInfo.AdditionalInfoItem
            ).map(key => ({
                ...this.AdditionalInfo.AdditionalInfoItem[key]
            }));

            // Add form controls dynamically for each additionalInfo field
            Object.keys(this.AdditionalInfo.AdditionalInfoItem).forEach(key => {
                const fieldConfig = this.AdditionalInfo.AdditionalInfoItem[key];
                // const validators = fieldConfig.required ? [Validators.required] : [];
                const validators = [Validators.required];
                this.leadGenForm.addControl(
                    'additionalInfoItem[' + key + ']',
                    new FormControl('', validators)
                );
            });
        }

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment === 'LEFT') {
            return 'text-left';
        } else if (alignment === 'CENTER') {
            return 'text-center';
        } else if (alignment === 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetch all courses.
     * This data is used in the course dropdown on the contact form
     */
    async fetchCourses() {

        await this.api.fetch_institutions()
            .subscribe(res => {
                this.courses = res.data.items;

            }, (err) => {

            });

    }

    saveChanges() {

        if (!this.leadGenForm.valid) {
            Object.keys(this.leadGenForm.controls).forEach(field => {
                const control = this.leadGenForm.get(field);
                control.markAsTouched({ onlySelf: true });
            });

            return false;
        }

        let user: any = localStorage.getItem('user');
        let userAccountKey: any = '';

        if (user) {
            try {
                user = JSON.parse(user);
                userAccountKey = user.Result.UserAccountKey._text;
            } catch (err) { }
        }

        const gaUserId = document.cookie.match(/_ga=(.+?)(?:;|$)/)?.[1].split('.').slice(-2).join('.');
        const frm = this.leadGenForm.getRawValue();

        // Get the Institution Object from the Course Key
        this.courseKey = this.module.prebuilt_module_data?.CourseKey;
        this.courseTitle = this.courses.find((obj) => {
            return Number(obj.identifier) === Number(this.courseKey);
        });

        const additionalInfoArr: any[] = [];
        if (this.additionalInfoExists) {
            Object.keys(this.AdditionalInfo?.AdditionalInfoItem).forEach(key => {
                const newValueObj = {
                    Question: (this.AdditionalInfo?.AdditionalInfoItem[key]?.Question !== undefined) ?
                        this.AdditionalInfo?.AdditionalInfoItem[key]?.Question :
                        this.AdditionalInfo?.AdditionalInfoItem[key]?.QuestionTextArea,
                    Answer: frm[`additionalInfoItem[${key}]`] ?? ''
                };
                // console.log('Additional Info Obj: ', newValueObj);
                additionalInfoArr.push(newValueObj);
            });
        }
        this.AdditionalInfo.AdditionalInfoItem = additionalInfoArr;

        const data = {
            firstName: frm.firstName,
            lastName: frm.lastName,
            emailAddress: frm.emailAddress,
            phoneNumber: frm.phoneNumber,
            institute: frm.institute?.short_title ?? this.courseTitle?.short_title,
            instituteKey: frm.institute?.identifier ?? this.courseKey,
            additional_info: this.AdditionalInfo,
            subscribe: frm.subscribe,

            // UTM Variables
            formName: 'Lead Gen',
            utmSource: sessionStorage.getItem('utmSource'),
            utmMedium: sessionStorage.getItem('utmMedium'),
            utmCampaign: sessionStorage.getItem('utmCampaign'),
            utmContent: sessionStorage.getItem('utmContent'),
            utmTerm: sessionStorage.getItem('utmTerm'),
            clientId: gaUserId,
            userId: userAccountKey
        };

        this.submitToApi(data);
    }

    async submitToApi(data) {

        this.processing = true;
        this.success = false;

        const redirectUrl = this.module.prebuilt_module_data.redirect_url ? this.module.prebuilt_module_data.redirect_url : false;

        await this.api.submit_lead_gen_form_data(data)
            .subscribe(res => {
                this.processing = false;
                this.cd.detectChanges();

                this.leadGenForm.reset();
                this.success = true;

                if (redirectUrl) {
                    this.router.navigateByUrl(redirectUrl);
                }
            }, (err) => {
                this.processing = false;
                this.cd.detectChanges();

                Swal.fire({
                    title: 'Error',
                    text: 'Unable to send your message',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showCloseButton: true,
                    customClass: 'swal-ibtc',
                    position: 'top'
                }).then((result) => {
                });
            });
    }

    /**
     * Easier access to the controlname reference
     */
    get f() {

        return this.leadGenForm.controls;

    }

    // Helper method to get keys for iteration in the template
    getAdditionalInfoKeys(): string[] {
        return Object.keys(this.AdditionalInfo.AdditionalInfoItem);
    }
}
